import { render, staticRenderFns } from "./Iap.vue?vue&type=template&id=56f03b27&scoped=true"
import script from "./Iap.vue?vue&type=script&lang=js"
export * from "./Iap.vue?vue&type=script&lang=js"
import style0 from "./Iap.vue?vue&type=style&index=0&id=56f03b27&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f03b27",
  null
  
)

export default component.exports